import { create } from "zustand";

export interface EditStore {
  selectedLocation: string | null;
  setSelectedLocation: (locaton: string | null) => void;
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  isDirtyAddress: boolean;
  setIsDirtyAddress: (isDirty: boolean) => void;
  isValidAddress: boolean;
  setIsValidAddress: (isValid: boolean) => void;
  resetState: () => void; // Add the resetState method
}

const useEditStore = create<EditStore>((setState) => ({
  selectedLocation: null,
  setSelectedLocation: (location) => setState({ selectedLocation: location }),
  isDirty: false,
  setIsDirty: (isDirty) => setState({ isDirty: isDirty }),
  isDirtyAddress: false,
  setIsDirtyAddress: (isDirty) => setState({ isDirtyAddress: isDirty }),
  isValidAddress: true,
  setIsValidAddress: (isValid) => setState({ isValidAddress: isValid }),
  resetState: () => {
    setState({
      selectedLocation: null,
      isDirty: false,
      isDirtyAddress: false,
      isValidAddress: true,
    });
  }, // Implement the resetState method
}));

export default useEditStore;
